import { HStack, Text } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';
import { CLASSNAME, formatCurrency } from '@skin-seoul/service';
import { Convert } from '@skin-seoul/utils';
export const ProductCardInfoPrice = () => {
  const {
    currency,
    originalPrice,
    salePrice
  } = useProductCard();
  return <HStack alignItems="center" gap={2} flexWrap="wrap" data-sentry-element="HStack" data-sentry-component="ProductCardInfoPrice" data-sentry-source-file="ProductCardInfoPrice.tsx">
      {salePrice ? <Convert value={salePrice} formatter={salePrice => <>
              <Text color="neutral.700" textStyle="paragraph.large" fontWeight="semibold" whiteSpace="nowrap" className={CLASSNAME.NOT_TRANSLATE}>
                {formatCurrency(currency, salePrice)}
              </Text>
              <Text color="neutral.400" textStyle="label.medium" fontWeight="normal" textDecoration="line-through" whiteSpace="nowrap" className={CLASSNAME.NOT_TRANSLATE}>
                {formatCurrency(currency, originalPrice)}
              </Text>
            </>} /> : <Text textStyle="paragraph.large" fontWeight="semibold" color="neutral.700" className={CLASSNAME.NOT_TRANSLATE}>
          {formatCurrency(currency, originalPrice)}
        </Text>}
    </HStack>;
};